var _title, _path, _path2, _circle, _path3, _circle2, _path4, _path5, _circle3, _path6, _path7, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOctorionHead = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275.9,
    height: 300,
    viewBox: "0 0 275.9 300",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "octorion_head")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.24,32.07a14,14,0,0,0-5.73,3.67c-1.16,1.39-.56,2.78,1.14,3.17,4.12,1,7.89-2.74,8.76-6.48.23-1-2.49-.56-2.7.35-.36,1.57-2.2,5.51-4.42,4.68-2.67-1,3.19-4,4-4.31.4-.15,1.06-.58.73-1.06s-1.4-.16-1.79,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136,0C71.52,0,18.68,42.41,13.56,96.34h-.37v.07h.37c0,.27-.07.54-.09.81h-.27V229.65s-4.1,15.61,42.59,37.53l58,28.61s21.55,10.4,46.69-1.49l74.91-37.53s20.92-7.12,23.34-27.39l.26-.19V96.63a2,2,0,0,0,0-.23v-.07C253.83,42.41,200.53,0,136,0Z",
    fill: "#cf262a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.95,
    cy: 141.78,
    r: 32.95,
    fill: "#b42028"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.95,165.68a23.9,23.9,0,1,1,23.9-23.9A23.92,23.92,0,0,1,32.95,165.68Z",
    fill: "#cf262a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.95,
    cy: 141.78,
    r: 32.95,
    fill: "#921a23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.95,165.68a23.9,23.9,0,1,1,23.9-23.9A23.92,23.92,0,0,1,32.95,165.68Z",
    fill: "#cf262a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.95,156.63A14.85,14.85,0,1,1,47.8,141.78,14.86,14.86,0,0,1,32.95,156.63Z",
    fill: "#921a23"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.95,
    cy: 141.78,
    r: 32.95,
    fill: "#921a23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.95,165.68a23.9,23.9,0,1,1,23.9-23.9A23.92,23.92,0,0,1,242.95,165.68Z",
    fill: "#cf262a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M242.95,156.63a14.85,14.85,0,1,1,14.85-14.85A14.86,14.86,0,0,1,242.95,156.63Z",
    fill: "#921a23"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.98,
    cy: 77.03,
    r: 12.14,
    fill: "#b42028"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.77,
    cy: 36.41,
    r: 7.72,
    fill: "#b42028"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.86,
    cy: 69.46,
    r: 9.99,
    fill: "#b42028"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.13,
    cy: 51.36,
    r: 9.99,
    fill: "#b42028"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.11,
    cy: 118.54,
    r: 4.77,
    fill: "#b42028"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.22,
    cy: 82.34,
    r: 4.77,
    fill: "#b42028"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 165.41,
    y1: 109.34,
    x2: 133.48,
    y2: 38.28,
    fill: "#921a23"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "128.84 72.13 133.48 38.28 165.41 109.34 128.84 72.13",
    fill: "#921a23"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "144.44 89.34 101.01 109.34 131.22 33.87 121.98 90.11 144.44 89.34",
    fill: "#921a23"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOctorionHead, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/octorion-head.909d8d08.svg";
export { ForwardRef as ReactComponent };